import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setStoredToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = anonymous, object = authenticated user
  const [user, setUser] = useState(null);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/mi/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  async function login(email, password) {
    const { data } = await api.post("/mi/auth/login", { email, password });
    if (data?.access_token) setStoredToken(data.access_token);
    setUser(data.user);
    return data.user;
  }

  async function register(payload) {
    const { data } = await api.post("/mi/auth/register", payload);
    if (data?.access_token) setStoredToken(data.access_token);
    setUser(data.user);
    return data.user;
  }

  async function logout() {
    try {
      await api.post("/mi/auth/logout");
    } catch {
      // ignore — we are clearing client state regardless
    }
    setStoredToken(null);
    setUser(false);
  }

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
